import {
    Avatar,
    Badge,
    Box, Heading,
    HStack,
    Icon,
    Progress,
    SimpleGrid,
    Spinner,
    Text,
    Tooltip
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { MdLocationOn, MdPendingActions } from 'react-icons/md';
import { fetchAllCouriersWidget } from '../../api';
const formatTime = (timeStr) => {
    if (!timeStr) return 'N/A';
    const [hour, minute] = timeStr.split(':');
    const h = parseInt(hour);
    const ampm = h >= 12 ? 'PM' : 'AM';
    const formattedHour = h % 12 || 12;
    return `${formattedHour}:${minute} ${ampm}`;
};

const WorkingCouriersWidget = () => {
    const [workingCouriers, setWorkingCouriers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getWorkingCouriers = async () => {
            setLoading(true);
            const response = await fetchAllCouriersWidget(1, 999);
            if (response.success) {
                const filtered = response.data.couriers.filter(c => c.isWorkingToday);
                setWorkingCouriers(filtered);

                console.log(filtered)
            }
            setLoading(false);
        };
        getWorkingCouriers();
    }, []);

    if (loading) return <Spinner size="md" />;

    return (
        <Box borderWidth="1px" borderRadius="lg" p={4} shadow="md">
            <Heading size="md" mb={4}>🚚 Couriers Working Today</Heading>
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
                {workingCouriers.map(courier => (
                    <Box key={courier._id} p={4} borderWidth="1px" borderRadius="lg" shadow="sm">
                        <HStack spacing={3} mb={3}>
                            <Avatar name={courier.name} size="sm" />
                            <Box>
                                <Text fontWeight="bold">{courier.name}</Text>
                                <Text fontSize="xs" color="gray.500">{courier.email}</Text>
                            </Box>
                            <Badge colorScheme="green" ml="auto">Working</Badge>
                        </HStack>

                        {/* Route & Start Time */}
                        <Text fontSize="sm" color="gray.600" mb={1}>
                            🛣 Route: <strong>{courier?.route?.name || 'N/A'}</strong>
                        </Text>
                        <Text fontSize="sm" color="gray.600" mb={3}>
                            🕒 Start: <strong>{formatTime(courier.scheduleStartTime)}</strong>
                        </Text>


                        <Text fontSize="sm" mb={1}>Progress</Text>
                        <Progress
                            value={courier.completionPercent}
                            colorScheme={courier.completionPercent >= 100 ? 'green' : 'blue'}
                            borderRadius="md"
                        />
                        <Text fontSize="xs" mt={1} color="gray.600">
                            {courier.completionPercent}% completed
                        </Text>

                        <Box mt={3}>
                            {courier.nextPickup ? (
                                <Tooltip
                                    label={`Next: ${courier.nextPickup.type} at ${courier.nextPickup.type === 'Default'
                                        ? courier.nextPickup.pickupLocationName
                                        : courier.nextPickup.dropOffLocationName}`}
                                >
                                    <HStack spacing={1}>
                                        <Icon as={MdLocationOn} color="blue.500" />
                                        <Text fontSize="sm">
                                            {courier.nextPickup.type === 'Default'
                                                ? courier.nextPickup.pickupLocationName
                                                : courier.nextPickup.dropOffLocationName}
                                        </Text>
                                    </HStack>
                                </Tooltip>
                            ) : (
                                <HStack spacing={1}>
                                    <Icon as={MdPendingActions} color="gray.500" />
                                    <Text fontSize="sm" color="gray.500">No destination</Text>
                                </HStack>
                            )}
                        </Box>
                    </Box>

                ))}
            </SimpleGrid>
        </Box>
    );
};

export default WorkingCouriersWidget;
